import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorsHandler } from './errors.handler';
import { BufferTextConverter } from '../buffer-text.converter';
import { HTTP_TOKEN_IGNORE_ERRORS } from '../serverroot.service';

export class ServerErrorsInterceptor implements HttpInterceptor {
    constructor(private errorsHandler: ErrorsHandler) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.context.get(HTTP_TOKEN_IGNORE_ERRORS)) {
            return next.handle(request);
        }

        return next.handle(request).pipe(catchError((error) => this.handleError(error)));
    }

    private handleError(error: any): Observable<never> {
        try {
            if (error.error instanceof ArrayBuffer) {
                error.error = BufferTextConverter.toJson(error.error);
            }
            this.errorsHandler.handleError(error);
        } catch (err) {
            console.error(err);
        }

        return throwError(() => error);
    }
}
